import { VacancyInfoRequirement } from 'utils/campaign/requirementUtils/types';
import { sortProfRoles } from 'utils/clickme';

import { Requirements } from 'app/routes';

import { PROF_ROLES, ProfRoles, setProfRoles } from 'store/autoReducers';
import { setBannerDefaultText } from 'store/models/bannerTextGeneration';
import {
    QuickCampaignConfigItem,
    QuickCampaignFieldName,
    resetQuickCampaignFormData,
    setQuickCampaignConfig,
    setQuickCampaignFieldByName,
    setQuickCampaignProfRoles,
    setQuickCampaignVacancyName,
} from 'store/models/createQuickCampaign';
import { selectMainMenuVacancyId } from 'store/models/mainMenu';

const AdQuickCreateRequirements: Requirements<{
    config: QuickCampaignConfigItem[];
    vacancyInfo: VacancyInfoRequirement;
    profRoles: { professionalCategories: ProfRoles[] };
}> = {
    methods: ({ state }) => {
        const vacancyId = selectMainMenuVacancyId(state);
        return {
            config: { url: '/api/v1/campaigns/quick_start_config' },
            ...(vacancyId && {
                vacancyInfo: { url: `/api/v1/vacancy/campaign_info_from_vacancy?vacancyId=${vacancyId}` },
            }),
            [PROF_ROLES]: { url: '/api/v1/catalog/professionalCatalog' },
        };
    },
    resolve: ({ state, result: { config, vacancyInfo, [PROF_ROLES]: profRoles } }) => [
        resetQuickCampaignFormData(null),
        setQuickCampaignConfig(config),
        setQuickCampaignFieldByName({
            fieldName: QuickCampaignFieldName.QuickStartType,
            value: config[0].type,
        }),
        setQuickCampaignFieldByName({
            fieldName: QuickCampaignFieldName.TotalBudget,
            value: config[0].minBudget,
        }),
        ...(vacancyInfo
            ? [
                  setQuickCampaignFieldByName({
                      fieldName: QuickCampaignFieldName.VacancyId,
                      value: selectMainMenuVacancyId(state),
                  }),
                  setQuickCampaignFieldByName({
                      fieldName: QuickCampaignFieldName.Title,
                      value: vacancyInfo.title,
                  }),
                  setQuickCampaignFieldByName({
                      fieldName: QuickCampaignFieldName.Text,
                      value: vacancyInfo.text,
                  }),
                  setQuickCampaignProfRoles(vacancyInfo.profRoleIds.map(String)),
                  setQuickCampaignVacancyName(vacancyInfo.title),
                  setBannerDefaultText(vacancyInfo.text),
              ]
            : []),
        ...(profRoles ? [setProfRoles(sortProfRoles(profRoles.professionalCategories))] : []),
    ],
};

export default AdQuickCreateRequirements;
